import {SuccessPageType} from 'desktop/pages/success/types/orderItemsTypes';

export const FILL_DR_DETAILS_OR_UPLOAD_FILE = 'fill dr details or upload file';
export const YOU_WILL_RECEIVE_A_CONFIRMATION = 'you will receive a confirmation';
export const DONT_FORGET_TO_SEND_US_YOUR_DR_DETAILS = 'dont forget to send us your dr details';
export const DONT_FORGET_TO_SEND_US_A_COPY_OF_YOUR_PRESCRIPTION =
    'dont forget to send us a copy of your prescription';
export const WE_WILL_VERIFY_THE_PRESCRIPTION = 'we will verify the prescription';
export const WE_GOT_IT = 'we got it';

export const initialState: SuccessPageType = {
    items: [],
    itemsValidated: {},
    orderedItems: [],
    status: 'pending',
    successScreen: FILL_DR_DETAILS_OR_UPLOAD_FILE,
    visiblyDetails: {
        errors: {},
        values: {dateOfBirth: '', state: ''},
    },
};
